import { createSlice } from '@reduxjs/toolkit';
import { createAppAsyncThunk } from '../../../common/thunk';
import DashboardService from '../../../services/dashboard.service';

interface SubdomainResponseProps {
  status: string;
}

export const validateDomain = createAppAsyncThunk('app/validateDomain', value => {
  return DashboardService.checkSubdomain(value).then(response => response.data);
});

interface DomainCheckState {
  available: boolean;
  status: string | null;
}
const initialState: DomainCheckState = {
  available: false,
  status: null,
};
export const domainCheckSlice = createSlice({
  name: 'domainCheck',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(validateDomain.pending, state => {
      state.available = false;
      state.status = '';
    });
    builder.addCase(validateDomain.rejected, state => {
      state.available = false;
      state.status = null;
    });
    builder.addCase(validateDomain.fulfilled, (state, action) => {
      const response = action.payload as SubdomainResponseProps;
      state.status = response.status;
      state.available = response.status === 'available';
    });
  },
});

export default domainCheckSlice.reducer;
